module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.studentReport) ? _c('div', [_c('img', {
    staticClass: "absolute",
    staticStyle: {
      "top": "52px",
      "left": "57px",
      "height": "calc(100% - 52px)",
      "width": "calc(100% - 57px)",
      "z-index": "10"
    },
    attrs: {
      "src": "/static/logos/static_student_report.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('pl-dialog', {
    attrs: {
      "size": 'md',
      "disableOutsideClick": true
    }
  }, [_c('header', {
    staticClass: "text-gray-700 flex justify-end items-center px-5 py-4"
  }, [_c('button', {
    staticClass: "w-7 h-7 focus:ring-2 focus:ring-offset-2 focus:ring-primary-dark rounded-full cursor-pointer hover:bg-gray-100 text-lg flex items-center justify-center hover:text-primary text-blueGray-700",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])]), _vm._v(" "), _c('body', {
    staticClass: "px-7 pb-10 flex flex-col flex-grow justify-center items-center overflow-y-auto"
  }, [_c('img', {
    staticClass: "w-14 mb-8",
    attrs: {
      "src": "/static/waffle_icons/unlock.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-2xl font-bold font-manrope"
  }, [_vm._v("\n        You've discovered a premium feature!\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-8 flex flex-col text-base font-normal"
  }, [_c('div', {
    staticClass: "flex justify-center font-manrope"
  }, [_vm._v("\n          Upgrading your Parlay account will unlock the " + _vm._s(_vm.text) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('button', {
    staticClass: "mb-2.5 px-8 py-2 bg-primary rounded cursor-pointer text-white font-manrope hover:bg-primary-dark",
    on: {
      "click": _vm.upgrade
    }
  }, [_vm._v("\n          Upgrade Now\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "px-8 py-2 bg-gray-100 hover:bg-gray-200 rounded cursor-pointer text-gray-500 font-manrope",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n          Maybe Later\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-49034106!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/upgradeModal.vue
// module id = 2396
// module chunks = 61